const labels = {
  calendarCtaView: 'View',
  calendarCtaViewAllEvents: 'View All Events',
  calendarCtaViewDay: 'View Day',
  calendarCtaClose: 'Close',
  datepickerFilterBtnNextMonth: 'Next month',
  datepickerFilterBtnNextWeek: 'Next week',
  datepickerFilterBtnToday: 'Today',
  datepickerFilterBtnTomorrow: 'Tomorrow',
  eventCardLabelLocation: 'Location',
  eventCardLabelTime: 'Time',
  eventCardsCtaBookNow: 'Book Today',
  eventCardsCtaLearnMore: 'Learn More',
  eventCardsCtaLoadMore: 'Load More',
  eventCardsCtaViewDetails: 'View Details',
  eventCardsEventsUnavailable:
    'There are no scheduled events found. Please try different filter(s).',
  eventCardsLabelFrom: 'From',
  eventCardsLabelNext: 'Next',
  eventCardsLabelPrev: 'Prev',
  filteredBarClearFilters: 'Clear Filters',
  filterLabelCategories: 'Type of Event',
  filterLabelDates: 'Pick your Dates',
  filterLabelLocations: 'Pick your Locations',
  filteredEventsBtnApply: 'Apply',
  filteredEventsBtnApplyFilter: 'Apply Filter',
  filteredEventsBtnClear: 'Clear',
  filteredEventsCategory: 'All',
  filteredEventsDate: 'Calendar',
  filteredEventsLocation: 'Location',
  filteredEventsTitle: 'Event Calendar'
}

export default labels
